import { PaletteOptions, PaletteMode } from '@mui/material';
import { GetThemeOptions } from '../theme';
import { blue, green, unityGreen, unityBlue } from './colors';

export const illustration = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['illustration'] => {
  if (opts.panwRebrandStubYear) {
    return mode === 'light'
      ? {
          blue1: unityBlue[100],
          blue2: unityBlue[200],
          green1: unityGreen[100],
          green2: unityGreen[300],
        }
      : {
          blue1: unityBlue[800],
          blue2: unityBlue[700],
          green1: unityGreen[800],
          green2: unityGreen[600],
        };
  }
  return mode === 'light'
    ? {
        blue1: blue[100],
        blue2: blue[200],
        green1: green[100],
        green2: green[300],
      }
    : {
        blue1: blue[800],
        blue2: blue[700],
        green1: green[800],
        green2: green[600],
      };
};
